import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { AnimatedLogo } from '../../../components/common/AnimatedLogo';

/**
 * BoardOverlay - A premium blurred overlay for the board area
 * Shown during data fetching or background updates
 */
interface BoardOverlayProps {
    isVisible: boolean;
    message?: string;
}

export const BoardOverlay: React.FC<BoardOverlayProps> = ({ isVisible, message }) => {
    return (
        <AnimatePresence>
            {isVisible && (
                <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    transition={{ duration: 0.4, ease: "easeInOut" }}
                    className="absolute inset-0 z-[40] flex items-center justify-center overflow-hidden rounded-lg pointer-events-auto"
                >
                    {/* 
            Blurred Overlay with Theme Tint
            - backdrop-blur-md for premium feel
            - bg-accent-primary/5 for subtle theme tinting
          */}
                    <motion.div
                        initial={{ backdropFilter: "blur(0px)", backgroundColor: "rgba(199, 97, 61, 0)" }}
                        animate={{ backdropFilter: "blur(12px)", backgroundColor: "rgba(199, 97, 61, 0.1)" }}
                        exit={{ backdropFilter: "blur(0px)", backgroundColor: "rgba(199, 97, 61, 0)" }}
                        className="absolute inset-0 transition-all duration-500"
                    />

                    {/* Animated Logo */}
                    <motion.div
                        initial={{ opacity: 0, scale: 0.8, filter: "blur(10px)" }}
                        animate={{ opacity: 1, scale: 1, filter: "blur(0px)" }}
                        exit={{ opacity: 0, scale: 1.1, filter: "blur(10px)" }}
                        transition={{ duration: 0.6, ease: [0.4, 0, 0.2, 1] }}
                        className="relative z-10"
                    >
                        <AnimatedLogo variant="processing" size="lg" />
                        {message && (
                            <div className="mt-6 text-center">
                                <span className="px-4 py-2 bg-white/80 dark:bg-neutral-900/80 backdrop-blur-md rounded-full text-sm font-medium text-neutral-800 dark:text-neutral-200 border border-border-default dark:border-neutral-800 shadow-sm">
                                    {message}
                                </span>
                            </div>
                        )}
                    </motion.div>
                </motion.div>
            )}
        </AnimatePresence>
    );
};

export default BoardOverlay;
